// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"TQ-z","inlineTitle":"UQ-z","sponsoredAdsWrapper":"VQ-z","marketplaceRecosWrapper":"WQ-z"};